import { AxiosPublicationsInstance } from "../api/AxiosInstance";

// Guides 2.0: llamadas crudas al backend, sin lógica de negocio (mismo
// patrón que GuidesRepository.js). VIVA-1268/1269: corregido para usar el
// gateway de publicaciones (API.Gateway.Pubs → API.Publish → assistance.usp*),
// que es donde en realidad viven estas 4 rutas (confirmado en Ocelot.json) —
// no el gateway general (AxiosInstance), que no las expone y habría dado 404.
//
// REACT_APP_GUIDES2_LOCAL_BASE_URL es un override solo para pruebas locales
// (ver .env.local): si está definida, las llamadas de esta feature van contra
// ese gateway local en vez de REACT_APP_BASE_URL_PUBLISH, sin afectar al resto
// de la app (AxiosPublicationsInstance sigue inyectando el Bearer normalmente
// vía interceptor porque axios resuelve una URL absoluta ignorando el
// baseURL configurado).
//
// El override aplica a los cuatro endpoints de la feature, no solo al de
// contenido: si apuntara únicamente a uno, el catálogo vendría de PRE y el
// contenido de local, con ids que no corresponden entre sí.
const GUIDES2_LOCAL_BASE_URL = process.env.REACT_APP_GUIDES2_LOCAL_BASE_URL || "";

const buildUrl = (path) =>
  GUIDES2_LOCAL_BASE_URL ? `${GUIDES2_LOCAL_BASE_URL}${path}` : path;

// Catálogo de guías. Ya NO es anónimo: corre bajo BearerPublic y el backend
// toma el usuario del JWT para auditoría, por eso el body no lleva id.
export const getGuidesCatalog = async (payload) => {
  try {
    return await AxiosPublicationsInstance.post(buildUrl("/api/obtener/catalogo-guias"), payload);
  } catch (error) {
    console.error("Error en getGuidesCatalog (Repository):", error);
    throw error;
  }
};

// Detalle de una guía. Devuelve una LISTA: una fila por variante activa
// (FREE y/o PAID), cada una con su guideVariantId y su hasAccess. Corre bajo
// BearerPublic y el usuario sale del JWT, así que el body ya no manda ningún
// id de usuario. Responde 404 cuando la guía no tiene variantes activas.
export const getGuideDetail = async (payload) => {
  try {
    return await AxiosPublicationsInstance.post(buildUrl("/api/obtener/detalle-guia"), payload);
  } catch (error) {
    console.error("Error en getGuideDetail (Repository):", error);
    throw error;
  }
};

// Guías compradas por el usuario autenticado. Aquí el backend sí resuelve el
// usuario desde el token, por eso el payload solo lleva el idioma.
export const getMyPurchasedGuides = async (payload) => {
  try {
    return await AxiosPublicationsInstance.post(buildUrl("/api/obtener/mis-guias-compradas"), payload);
  } catch (error) {
    console.error("Error en getMyPurchasedGuides (Repository):", error);
    throw error;
  }
};

// Contenido de una variante concreta. El backend ya no responde con error
// cuando el usuario no tiene acceso: devuelve 200 con data.hasAccess = false y
// name/description/content/fileUrl en null, así que quien consuma esto debe
// revisar hasAccess antes de renderizar nada.
export const getGuideContent = async (payload) => {
  try {
    return await AxiosPublicationsInstance.post(buildUrl("/api/obtener/contenido-guia"), payload);
  } catch (error) {
    console.error("Error en getGuideContent (Repository):", error);
    throw error;
  }
};

// ---------------------------------------------------------------------------
// VIVA-1214 — cobro de guías con Stripe (API.Stripe detrás del mismo gateway).
//
// El comprador SIEMPRE sale del token: ningún payload lleva idUsuario,
// authorUserId ni requestingUserId (contrato de backend del 22/09/2026).
// ---------------------------------------------------------------------------

// Desglose calculado en servidor: base, descuento Beta, cupón, piso y total en
// USD. Es la única fuente del total que se muestra antes de pagar.
export const getGuidePricePreview = async (params) => {
  try {
    return await AxiosPublicationsInstance.get(buildUrl("/api/guia/precio-preview"), { params });
  } catch (error) {
    console.error("Error en getGuidePricePreview (Repository):", error);
    throw error;
  }
};

// Crea el PaymentIntent. Devuelve paymentIntentId y clientSecret.
export const createGuidePaymentIntent = async (payload) => {
  try {
    return await AxiosPublicationsInstance.post(buildUrl("/api/create-payment-intent-generico"), payload);
  } catch (error) {
    console.error("Error en createGuidePaymentIntent (Repository):", error);
    throw error;
  }
};

export const getPaymentIntentStatus = async (paymentIntentId) => {
  try {
    return await AxiosPublicationsInstance.get(
      buildUrl(`/api/payment-intent/${encodeURIComponent(paymentIntentId)}/status`)
    );
  } catch (error) {
    console.error("Error en getPaymentIntentStatus (Repository):", error);
    throw error;
  }
};

export const cancelPaymentIntent = async (payload) => {
  try {
    return await AxiosPublicationsInstance.post(buildUrl("/api/payment-intent/cancel"), payload);
  } catch (error) {
    console.error("Error en cancelPaymentIntent (Repository):", error);
    throw error;
  }
};

export const refundGuide = async (payload) => {
  try {
    return await AxiosPublicationsInstance.post(buildUrl("/api/reembolsar-guia"), payload);
  } catch (error) {
    console.error("Error en refundGuide (Repository):", error);
    throw error;
  }
};
